module.exports = __webpack_public_path__ + "img/ic_share_all.003643f0.png";